import { render, staticRenderFns } from "./AiDisclosureSummary.vue?vue&type=template&id=edd872c2&scoped=true"
import script from "./AiDisclosureSummary.vue?vue&type=script&lang=js"
export * from "./AiDisclosureSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd872c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalCloseButton: require('/vercel/path0/components/ModalCloseButton.vue').default,AiDisclosureSummaryContent: require('/vercel/path0/components/AiDisclosureSummaryContent.vue').default,AiDisclosureFinanceContent: require('/vercel/path0/components/AiDisclosureFinanceContent.vue').default})
